import React, { useState } from 'react';
import './SalesforceAIBootcamp.css';
import { useParams, useNavigate } from 'react-router-dom';


const SalesforceAIBootcamp = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send data to your backend
    setSubmitted(true);
  };

  return (
    <div className="ai-bootcamp-container">
      <header className="bootcamp-header">
        <div className="header-content">
          <h1>Salesforce AI App Development Bootcamp</h1>
          <p className="subtitle">Build AI-Powered Apps in Just 1 Week</p>
          <div className="price-tag">
            <span className="original-price">₹10000.00</span>
            <span className="discounted-price">₹499.00</span>
            <span className="discount-badge">95% OFF</span>
          </div>
          <a href="#register" className="ctaSAI-button">Enroll Now</a>
        </div>
      </header>

      <section className="key-features">
        <h2>What You'll Learn</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="icon">🤖</div>
            <h3>Einstein AI Integration</h3>
            <p>Learn to embed predictive AI into your Salesforce apps</p>
          </div>
          <div className="feature-card">
            <div className="icon">🧠</div>
            <h3>AI App Development</h3>
            <p>Build apps that leverage natural language processing</p>
          </div>
          <div className="feature-card">
            <div className="icon">🏆</div>
            <h3>Certification Prep</h3>
            <p>Guidance for Salesforce AI Associate certification</p>
          </div>
          <div className="feature-card">
            <div className="icon">🛠️</div>
            <h3>Hands-On Projects</h3>
            <p>Real-world AI implementations you can showcase</p>
          </div>
        </div>
      </section>

      <section className="curriculum-section">
        <h2>7-Day Intensive Curriculum</h2>
        <div className="day-cards">
          <div className="day-card">
            <h3>Day 1: AI Fundamentals</h3>
            <ul>
              <li>Salesforce AI ecosystem overview</li>
              <li>Einstein Platform Services</li>
              <li>Setting up your AI workspace</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 2: Predictive Builder</h3>
            <ul>
              <li>Creating prediction models</li>
              <li>Training data preparation</li>
              <li>Field-level predictions</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 3: Natural Language</h3>
            <ul>
              <li>Einstein Language basics</li>
              <li>Sentiment analysis</li>
              <li>Intent detection</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 4: Vision & Bots</h3>
            <ul>
              <li>Image recognition</li>
              <li>Chatbot integration</li>
              <li>Omni-channel AI</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 5: AI in Flow</h3>
            <ul>
              <li>Einstein in Process Builder</li>
              <li>AI-powered approvals</li>
              <li>Smart workflows</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 6: Project Workshop</h3>
            <ul>
              <li>Building an AI recommendation engine</li>
              <li>Implementing in a sample org</li>
              <li>Testing and validation</li>
            </ul>
          </div>
          <div className="day-card">
            <h3>Day 7: Certification Prep</h3>
            <ul>
              <li>AI Associate exam overview</li>
              <li>Practice questions</li>
              <li>Career next steps</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="instructor-section">
        <h2>Your AI Mentor</h2>
        <div className="instructor-card">
          <img src="https://randomuser.me/api/portraits/women/45.jpg" alt="Instructor" className="instructor-photo" />
          <div className="instructor-info">
            <h3>Dr. Priya Sharma</h3>
            <p className="title">Salesforce AI Architect</p>
            <p className="bio">10+ years implementing AI solutions for Fortune 500 companies. Former Einstein Product Manager at Salesforce.</p>
            <div className="credentials">
              <span className="credential">PhD Artificial Intelligence</span>
              <span className="credential">5x Salesforce Certified</span>
              <span className="credential">Einstein Specialist</span>
            </div>
          </div>
        </div>
      </section>

      <section id="register" className={`registration-section ${submitted ? 'submitted' : ''}`}>
        {submitted ? (
          <div className="thank-you-message">
            <h2>Thank You for Registering!</h2>
            <p>We've sent the bootcamp details to your email. Check your inbox for next steps.</p>
            <button onClick={() => setSubmitted(false)} className="cta-button">Register Another Person</button>
          </div>
        ) : (
          <>
            <h2>Secure Your Spot Now</h2>
            <p className="limited-seats">Only 30 seats available at this price!</p>
            <form onSubmit={handleSubmit} className="registration-form">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">WhatsApp Number</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleChange}
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="experience">Salesforce Experience</label>
                <select 
                  id="experience" 
                  name="experience" 
                  value={formData.experience}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select your level</option>
                  <option value="beginner">Beginner</option>
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>
              <button type="submit" className="cta-button">Register Now for ₹499</button>
              <p className="payment-note">Payment link will be sent after registration</p>
            </form>
          </>
        )}
      </section>

      <footer className="bootcamp-footer">
        <p>© 2025 Salesforce AI Bootcamp. All rights reserved.</p>
        <div className="footer-links">
          <a href="#/">Terms of Service</a>
          <a href="#/">Privacy Policy</a>
          <a href="#/">Contact Us</a>
        </div>
      </footer>
    </div>
  );
};

export default SalesforceAIBootcamp;